
import React from 'react';
import '../Stile/Galleria.css'; // Assicurati di creare un file CSS per stili aggiuntivi

const Image = ({ src, className }) => {
  return <img src={src} alt="Immagine" className={className} />;
};

export default Image;
